// extracted by mini-css-extract-plugin
export default {"input":"CommonInputDate_input__+FsjU","label":"CommonInputDate_label__fRy-a"};